import { BreakpointsOptions } from '@mui/system';

export const breakpoints: BreakpointsOptions = {
  values: {
    mobileExtra: 0,
    mobile: 460,
    tablet: 640,
    laptop: 1100,
    desktop: 1440,
  },
};

declare module '@mui/material/styles' {
  interface BreakpointOverrides {
    xs: false;
    sm: false;
    md: false;
    lg: false;
    xl: false;
    mobileExtra: true;
    mobile: true;
    tablet: true;
    laptop: true;
    desktop: true;
  }
}
